function cleanText(value) {
  return String(value || "").replace(/\s+/g, " ").trim();
}

function wordCount(value) {
  return cleanText(value).split(" ").filter(Boolean).length;
}

export function looksLikeDiagnosis(value) {
  const text = cleanText(value);
  if (!text) return false;

  const normalized = text.toLowerCase();
  const noteLikeStarts = [
    "take ",
    "use ",
    "apply ",
    "continue ",
    "start ",
    "stop ",
    "avoid ",
    "monitor ",
    "follow up",
    "review ",
    "prescribe ",
  ];
  if (noteLikeStarts.some((prefix) => normalized.startsWith(prefix))) return false;

  const noteLikePhrases = [
    "tablet",
    "capsule",
    "medication",
    "prescription",
    "every ",
    "daily",
    "weekly",
    "monthly",
    "for a month",
    "for one month",
    "as needed",
    "before meals",
    "after meals",
  ];
  if (noteLikePhrases.some((phrase) => normalized.includes(phrase))) return false;

  if (wordCount(text) > 10 && /[,.]/.test(text)) return false;

  return true;
}

export function pickDiagnosisTitle(...values) {
  for (const value of values) {
    const text = cleanText(value);
    if (!text) continue;
    if (looksLikeDiagnosis(text)) return text;
  }
  return "";
}

export function pickDiagnosisNotes(...values) {
  for (const value of values) {
    const text = cleanText(value);
    if (text) return text;
  }
  return "";
}
